var items = {
  "block.minecraft.air": "lucht",
  "block.minecraft.stone": "stien",
  "block.minecraft.granite": "granyt",
  "block.minecraft.polished_granite": "polyste granyt",
  "block.minecraft.diorite": "dioryt",
  "block.minecraft.polished_diorite": "polyste dioryt",
  "block.minecraft.andesite": "andesyt",
  "block.minecraft.polished_andesite": "polyste andesyt",
  "block.minecraft.grass_block": "blok gers",
  "block.minecraft.dirt": "ierde",
  "block.minecraft.coarse_dirt": "rûge ierde",
  "block.minecraft.podzol": "podsol",
  "block.minecraft.crimson_nylium": "helread nylium",
  "block.minecraft.warped_nylium": "spûkeftich nylium",
  "block.minecraft.cobblestone": "balstien",
  "block.minecraft.oak_planks": "ikehouten planken",
  "block.minecraft.spruce_planks": "spjirrehouten planken",
  "block.minecraft.birch_planks": "bjirkehouten planken",
  "block.minecraft.jungle_planks": "oerwâldhouten planken",
  "block.minecraft.acacia_planks": "akasiahouten planken",
  "block.minecraft.dark_oak_planks": "donkere ikehouten planken",
  "block.minecraft.crimson_planks": "helreade houten planken",
  "block.minecraft.warped_planks": "spûkeftige houten planken",
  "block.minecraft.oak_sapling": "ikekymplant",
  "block.minecraft.spruce_sapling": "spjirrekymplant",
  "block.minecraft.birch_sapling": "bjirkekymplant",
  "block.minecraft.jungle_sapling": "oerwâldkymplant",
  "block.minecraft.acacia_sapling": "akasiakymplant",
  "block.minecraft.dark_oak_sapling": "donkere ikekymplant",
  "block.minecraft.bedrock": "boaiemstien",
  "block.minecraft.sand": "sân",
  "block.minecraft.red_sand": "read sân",
  "block.minecraft.gravel": "gryn",
  "block.minecraft.gold_ore": "gouderts",
  "block.minecraft.iron_ore": "izererts",
  "block.minecraft.coal_ore": "stienkoalerts",
  "block.minecraft.nether_gold_ore": "nethergoudenerts",
  "block.minecraft.oak_log": "ikestam",
  "block.minecraft.spruce_log": "spjirrestam",
  "block.minecraft.birch_log": "bjirkestam",
  "block.minecraft.jungle_log": "oerwâldstam",
  "block.minecraft.acacia_log": "akasiastam",
  "block.minecraft.dark_oak_log": "donkere ikestam",
  "block.minecraft.crimson_stem": "helreade stam",
  "block.minecraft.warped_stem": "spûkeftige stam",
  "block.minecraft.stripped_oak_log": "stripte ikestam",
  "block.minecraft.stripped_spruce_log": "stripte spjirrestam",
  "block.minecraft.stripped_birch_log": "stripte bjirkestam",
  "block.minecraft.stripped_jungle_log": "stripte oerwâldstam",
  "block.minecraft.stripped_acacia_log": "stripte akasiastam",
  "block.minecraft.stripped_dark_oak_log": "stripte donker ikestam",
  "block.minecraft.stripped_crimson_stem": "stripte helreade stam",
  "block.minecraft.stripped_warped_stem": "stripte spûkeftige stam",
  "block.minecraft.stripped_oak_wood": "stripte ikehout",
  "block.minecraft.stripped_spruce_wood": "stripte spjirrehout",
  "block.minecraft.stripped_birch_wood": "stripte bjirkehout",
  "block.minecraft.stripped_jungle_wood": "stripte oerwâldhout",
  "block.minecraft.stripped_acacia_wood": "stripte akasiahout",
  "block.minecraft.stripped_dark_oak_wood": "stripte donker ikehout",
  "block.minecraft.stripped_crimson_hyphae": "stripte helreade skimmeltrieden",
  "block.minecraft.stripped_warped_hyphae": "stripte spûkeftige skimmeltrieden",
  "block.minecraft.oak_wood": "ikehout",
  "block.minecraft.spruce_wood": "spjirrehout",
  "block.minecraft.birch_wood": "bjirkehout",
  "block.minecraft.jungle_wood": "oerwâldhout",
  "block.minecraft.acacia_wood": "akasiahout",
  "block.minecraft.dark_oak_wood": "donker ikehout",
  "block.minecraft.crimson_hyphae": "helreade skimmeltrieden",
  "block.minecraft.warped_hyphae": "spûkeftige skimmeltrieden",
  "block.minecraft.oak_leaves": "ikeblêden",
  "block.minecraft.spruce_leaves": "spjirrenullen",
  "block.minecraft.birch_leaves": "bjirkeblêden",
  "block.minecraft.jungle_leaves": "oerwâldblêden",
  "block.minecraft.acacia_leaves": "akasiablêden",
  "block.minecraft.dark_oak_leaves": "donkere ikeblêden",
  "block.minecraft.sponge": "spûns",
  "block.minecraft.wet_sponge": "wiete spûns",
  "block.minecraft.glass": "glês",
  "block.minecraft.lapis_ore": "lapis lazuli-erts",
  "block.minecraft.lapis_block": "lapis lazuliblok",
  "block.minecraft.dispenser": "smiter",
  "block.minecraft.sandstone": "sânstien",
  "block.minecraft.chiseled_sandstone": "beitele sânstien",
  "block.minecraft.cut_sandstone": "sneden sânstien",
  "block.minecraft.note_block": "noateblok",
  "block.minecraft.powered_rail": "oandriuwspoar",
  "block.minecraft.detector_rail": "deteksjespoar",
  "block.minecraft.sticky_piston": "kleefsûger",
  "block.minecraft.cobweb": "spinreach",
  "block.minecraft.grass": "gers",
  "block.minecraft.fern": "faren",
  "block.minecraft.dead_bush": "deade strûk",
  "block.minecraft.seagrass": "seegers",
  "block.minecraft.sea_pickle": "see-augurk",
  "block.minecraft.piston": "sûger",
  "block.minecraft.white_wool": "wite wol",
  "block.minecraft.orange_wool": "oranje wol",
  "block.minecraft.magenta_wool": "magenta wol",
  "block.minecraft.light_blue_wool": "ljochtblauwe wol",
  "block.minecraft.yellow_wool": "giele wol",
  "block.minecraft.lime_wool": "ljochtgriene wol",
  "block.minecraft.pink_wool": "rôze wol",
  "block.minecraft.gray_wool": "grize wol",
  "block.minecraft.light_gray_wool": "ljochtgrize wol",
  "block.minecraft.cyan_wool": "syane wol",
  "block.minecraft.purple_wool": "pearze wol",
  "block.minecraft.blue_wool": "blauwe wol",
  "block.minecraft.brown_wool": "brune wol",
  "block.minecraft.green_wool": "griene wol",
  "block.minecraft.red_wool": "reade wol",
  "block.minecraft.black_wool": "swarte wol",
  "block.minecraft.dandelion": "hynsteblom",
  "block.minecraft.poppy": "klaproas",
  "block.minecraft.blue_orchid": "blauwe orchidee",
  "block.minecraft.allium": "wylde sipel",
  "block.minecraft.azure_bluet": "porselynstjerke",
  "block.minecraft.red_tulip": "reade tulp",
  "block.minecraft.orange_tulip": "oranje tulp",
  "block.minecraft.white_tulip": "wite tulp",
  "block.minecraft.pink_tulip": "rôze tulp",
  "block.minecraft.oxeye_daisy": "guozzeblom",
  "block.minecraft.cornflower": "roggeblom",
  "block.minecraft.lily_of_the_valley": "maaieklokje",
  "block.minecraft.wither_rose": "witherroas",
  "block.minecraft.brown_mushroom": "brune poddestoel",
  "block.minecraft.red_mushroom": "reade poddestoel",
  "block.minecraft.crimson_fungus": "helreade swam",
  "block.minecraft.warped_fungus": "spûkeftige swam",
  "block.minecraft.crimson_roots": "helreade woartels",
  "block.minecraft.warped_roots": "spûkeftige woartels",
  "block.minecraft.nether_sprouts": "nethersprútsjes",
  "block.minecraft.weeping_vines": "hingjende klimmerblêd",
  "block.minecraft.twisting_vines": "draaiende lianen",
  "block.minecraft.sugar_cane": "sûkerreid",
  "block.minecraft.kelp": "kelp",
  "block.minecraft.bamboo": "bamboe",
  "block.minecraft.gold_block": "blok goud",
  "block.minecraft.iron_block": "blok izer",
  "block.minecraft.oak_slab": "ikehouten plaat",
  "block.minecraft.spruce_slab": "spjirrehouten plaat",
  "block.minecraft.birch_slab": "bjirkehouten plaat",
  "block.minecraft.jungle_slab": "oerwâldhouten plaat",
  "block.minecraft.acacia_slab": "akasiahouten plaat",
  "block.minecraft.dark_oak_slab": "donkere ikehouten plaat",
  "block.minecraft.crimson_slab": "helreade houten plaat",
  "block.minecraft.warped_slab": "spûkeftige houten plaat",
  "block.minecraft.stone_slab": "stiennen plaat",
  "block.minecraft.smooth_stone_slab": "glêde sânstien",
  "block.minecraft.sandstone_slab": "sânstiennen plaat",
  "block.minecraft.cut_sandstone_slab": "sneden sânstiennen plaat",
  "block.minecraft.petrified_oak_slab": "ferstiene ikehouten plaat",
  "block.minecraft.cobblestone_slab": "balstiennen plaat",
  "block.minecraft.brick_slab": "bakstiennen plaat",
  "block.minecraft.stone_brick_slab": "blokstiennen plaat",
  "block.minecraft.nether_brick_slab": "netherbakstiennen plaat",
  "block.minecraft.quartz_slab": "kwartsplaat",
  "block.minecraft.red_sandstone_slab": "reade sânstiennen plaat",
  "block.minecraft.cut_red_sandstone_slab": "sneden reade sânstiennen plaat",
  "block.minecraft.purpur_slab": "purpurplaat",
  "block.minecraft.prismarine_slab": "prismarine plaat",
  "block.minecraft.prismarine_brick_slab": "prismarine stiennen plaat",
  "block.minecraft.dark_prismarine_slab": "donkere prismarine plaat",
  "block.minecraft.smooth_quartz": "glêd kwartsblok",
  "block.minecraft.smooth_red_sandstone": "glêde reade sânstien",
  "block.minecraft.smooth_sandstone": "glêde sânstien",
  "block.minecraft.smooth_stone": "glêde stien",
  "block.minecraft.bricks": "bakstiennen",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "boekekast",
  "block.minecraft.mossy_cobblestone": "moassige balstiennen",
  "block.minecraft.obsidian": "obsidiaan",
  "block.minecraft.torch": "fakkel",
  "block.minecraft.end_rod": "end-stêf",
  "block.minecraft.chorus_plant": "koarplant",
  "block.minecraft.chorus_flower": "koarblom",
  "block.minecraft.purpur_block": "purpurblok",
  "block.minecraft.purpur_pillar": "purpurpylder",
  "block.minecraft.purpur_stairs": "purpurtrep",
  "block.minecraft.spawner": "meunsterkoai",
  "block.minecraft.oak_stairs": "ikehouten trep",
  "block.minecraft.chest": "kiste",
  "block.minecraft.diamond_ore": "diamanterts",
  "block.minecraft.diamond_block": "diamantblok",
  "block.minecraft.crafting_table": "wurkbank",
  "block.minecraft.farmland": "boulân",
  "block.minecraft.furnace": "oven",
  "block.minecraft.ladder": "ljedder",
  "block.minecraft.rail": "spoar",
  "block.minecraft.cobblestone_stairs": "balstiennen trep",
  "block.minecraft.lever": "hânsel",
  "block.minecraft.stone_pressure_plate": "stiennen drukplaat",
  "block.minecraft.oak_pressure_plate": "ikehouten drukplaat",
  "block.minecraft.spruce_pressure_plate": "spjirrehouten drukplaat",
  "block.minecraft.birch_pressure_plate": "bjirkehouten drukplaat",
  "block.minecraft.jungle_pressure_plate": "oerwâldhouten drukplaat",
  "block.minecraft.acacia_pressure_plate": "akasiahouten drukplaat",
  "block.minecraft.dark_oak_pressure_plate": "donker ikehouten drukplaat",
  "block.minecraft.crimson_pressure_plate": "helreade houten drukplaat",
  "block.minecraft.warped_pressure_plate": "spûkeftige houten drukplaat",
  "block.minecraft.polished_blackstone_pressure_plate": "polyste swartstiennen drukplaat",
  "block.minecraft.redstone_ore": "redstone-erts",
  "block.minecraft.redstone_torch": "redstonefakkel",
  "block.minecraft.snow": "snie",
  "block.minecraft.ice": "iis",
  "block.minecraft.snow_block": "snieblok",
  "block.minecraft.cactus": "kaktus",
  "block.minecraft.clay": "klaai",
  "block.minecraft.jukebox": "jukebox",
  "block.minecraft.oak_fence": "ikehouten stek",
  "block.minecraft.spruce_fence": "spjirrehouten stek",
  "block.minecraft.birch_fence": "bjirkehouten stek",
  "block.minecraft.jungle_fence": "oerwâldhouten stek",
  "block.minecraft.acacia_fence": "akasiahouten stek",
  "block.minecraft.dark_oak_fence": "donkere ikehouten stek",
  "block.minecraft.crimson_fence": "helreade houten hek",
  "block.minecraft.warped_fence": "spûkeftich houten hek",
  "block.minecraft.pumpkin": "pompoen",
  "block.minecraft.carved_pumpkin": "bewurke pompoen",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "sielesân",
  "block.minecraft.soul_soil": "siele-ierde",
  "block.minecraft.basalt": "basalt",
  "block.minecraft.polished_basalt": "polyste basalt",
  "block.minecraft.soul_torch": "sielefakkel",
  "block.minecraft.glowstone": "gleonstien",
  "block.minecraft.jack_o_lantern": "jack o'lantern",
  "block.minecraft.oak_trapdoor": "ikehouten fallûk",
  "block.minecraft.spruce_trapdoor": "spjirrehouten fallûk",
  "block.minecraft.birch_trapdoor": "bjirkehouten fallûk",
  "block.minecraft.jungle_trapdoor": "oerwâldhouten fallûk",
  "block.minecraft.acacia_trapdoor": "akasiahouten fallûk",
  "block.minecraft.dark_oak_trapdoor": "donker ikehouten fallûk",
  "block.minecraft.crimson_trapdoor": "helreade houten fallûk",
  "block.minecraft.warped_trapdoor": "spûkeftich houten fallûk",
  "block.minecraft.infested_stone": "ynfektearre stien",
  "block.minecraft.infested_cobblestone": "ynfektearre keistien",
  "block.minecraft.infested_stone_bricks": "ynfektearre blokstiennen",
  "block.minecraft.infested_mossy_stone_bricks": "ynfektearre moassige blokstienen",
  "block.minecraft.infested_cracked_stone_bricks": "ynfektearre barsten blokstiennen",
  "block.minecraft.infested_chiseled_stone_bricks": "ynfektearre slepen blokstiennen",
  "block.minecraft.stone_bricks": "blokstiennen",
  "block.minecraft.mossy_stone_bricks": "moassige blokstiennen",
  "block.minecraft.cracked_stone_bricks": "barste blokstiennen",
  "block.minecraft.chiseled_stone_bricks": "bewurke blokstiennen",
  "block.minecraft.brown_mushroom_block": "brune poddestuolleblok",
  "block.minecraft.red_mushroom_block": "reade poddestoeleblok",
  "block.minecraft.mushroom_stem": "poddestuollensnuorrepot",
  "block.minecraft.iron_bars": "izeren traaljes",
  "block.minecraft.chain": "ketting",
  "block.minecraft.glass_pane": "glêzen rút",
  "block.minecraft.melon": "wettermeloen",
  "block.minecraft.vine": "lianen",
  "block.minecraft.oak_fence_gate": "ikehouten stekpoartsje",
  "block.minecraft.spruce_fence_gate": "spjirrehouten stekpoartsje",
  "block.minecraft.birch_fence_gate": "bjirkehouten stekpoartsje",
  "block.minecraft.jungle_fence_gate": "oerwâldhouten stekpoartsje",
  "block.minecraft.acacia_fence_gate": "akasiahouten stekpoartsje",
  "block.minecraft.dark_oak_fence_gate": "donkere ikehouten stekpoartsje",
  "block.minecraft.crimson_fence_gate": "helreade houten poarte",
  "block.minecraft.warped_fence_gate": "spûkeftich houten poarte",
  "block.minecraft.brick_stairs": "bakstiennen trep",
  "block.minecraft.stone_brick_stairs": "houstiennen trep",
  "block.minecraft.mycelium": "swamflok",
  "block.minecraft.lily_pad": "pompeblêd",
  "block.minecraft.nether_bricks": "netherbakstiennen",
  "block.minecraft.cracked_nether_bricks": "kreake nether-bakstien",
  "block.minecraft.chiseled_nether_bricks": "beitele nether-bakstien",
  "block.minecraft.nether_brick_fence": "nether-bakstiennen stek",
  "block.minecraft.nether_brick_stairs": "nether-bakstiennen trêden",
  "block.minecraft.enchanting_table": "betsjoeningstafel",
  "block.minecraft.end_portal_frame": "endportaalframe",
  "block.minecraft.end_stone": "end-stien",
  "block.minecraft.end_stone_bricks": "end-houstiennen",
  "block.minecraft.dragon_egg": "drake-aai",
  "block.minecraft.redstone_lamp": "redstone-lampe",
  "block.minecraft.sandstone_stairs": "sânstiennen trep",
  "block.minecraft.emerald_ore": "smaragderts",
  "block.minecraft.ender_chest": "ender-kiste",
  "block.minecraft.tripwire_hook": "stroffeltriedheak",
  "block.minecraft.emerald_block": "smaragdblok",
  "block.minecraft.spruce_stairs": "spjirrehouten trep",
  "block.minecraft.birch_stairs": "bakstiennen trep",
  "block.minecraft.jungle_stairs": "oerwâldhouten trep",
  "block.minecraft.crimson_stairs": "helreade houten trep",
  "block.minecraft.warped_stairs": "spûkeftich houten trep",
  "block.minecraft.command_block": "opdrachtblok",
  "block.minecraft.beacon": "beaken",
  "block.minecraft.cobblestone_wall": "balstiennen muorre",
  "block.minecraft.mossy_cobblestone_wall": "moassige balstiennen muorre",
  "block.minecraft.brick_wall": "bakstiennen muorre",
  "block.minecraft.prismarine_wall": "prismarinemuorre",
  "block.minecraft.red_sandstone_wall": "reade sânstiennen muorre",
  "block.minecraft.mossy_stone_brick_wall": "moassich blokstiennen muorre",
  "block.minecraft.granite_wall": "graniten muorre",
  "block.minecraft.stone_brick_wall": "blokstiennen muorre",
  "block.minecraft.nether_brick_wall": "netherbakstiennen muorre",
  "block.minecraft.andesite_wall": "andesytmuorre",
  "block.minecraft.red_nether_brick_wall": "reade netherbakstiennen muorre",
  "block.minecraft.sandstone_wall": "sânstiennen muorre",
  "block.minecraft.end_stone_brick_wall": "einblokstiennen muorre",
  "block.minecraft.diorite_wall": "diorytmuorre",
  "block.minecraft.blackstone_wall": "swartstiennen muorre",
  "block.minecraft.polished_blackstone_wall": "polyste swartstiennen muorre",
  "block.minecraft.polished_blackstone_brick_wall": "polyste swartstiennen blokstiennen muorre",
  "block.minecraft.stone_button": "stiennen knop",
  "block.minecraft.oak_button": "ikehouten knop",
  "block.minecraft.spruce_button": "spjirrehouten knop",
  "block.minecraft.birch_button": "bjirkehouten knop",
  "block.minecraft.jungle_button": "oerwâldhouten knop",
  "block.minecraft.acacia_button": "akasiahouten knop",
  "block.minecraft.dark_oak_button": "donker ikehouten knop",
  "block.minecraft.crimson_button": "helreade houten knop",
  "block.minecraft.warped_button": "spûkeftich houten knop",
  "block.minecraft.polished_blackstone_button": "polyste swartstiennen knop",
  "block.minecraft.anvil": "ambyld",
  "block.minecraft.chipped_anvil": "barsten ambyld",
  "block.minecraft.damaged_anvil": "skansearre ambyld",
  "block.minecraft.trapped_chest": "kiste mei falstrik",
  "block.minecraft.light_weighted_pressure_plate": "ljochtgefoelige drukplaat",
  "block.minecraft.heavy_weighted_pressure_plate": "swiergefoelige drukplaat",
  "block.minecraft.daylight_detector": "deiljochtsensor",
  "block.minecraft.redstone_block": "redstone-blok",
  "block.minecraft.nether_quartz_ore": "nether-kwartserts",
  "block.minecraft.hopper": "trachter",
  "block.minecraft.chiseled_quartz_block": "beitele kwartsblok",
  "block.minecraft.quartz_block": "kwartsblok",
  "block.minecraft.quartz_bricks": "kwartsblokstiennen",
  "block.minecraft.quartz_pillar": "kwartspilaar",
  "block.minecraft.quartz_stairs": "kwartstrep",
  "block.minecraft.activator_rail": "aktivaasjespoar",
  "block.minecraft.dropper": "jouwer",
  "block.minecraft.white_terracotta": "wite terrakotta",
  "block.minecraft.orange_terracotta": "oranje terrakotta",
  "block.minecraft.magenta_terracotta": "magenta terrakotta",
  "block.minecraft.light_blue_terracotta": "ljochtblauwe terrakotta",
  "block.minecraft.yellow_terracotta": "giele terrakotta",
  "block.minecraft.lime_terracotta": "ljochtgriene terrakotta",
  "block.minecraft.pink_terracotta": "rôze terrakotta",
  "block.minecraft.gray_terracotta": "grize terrakotta",
  "block.minecraft.light_gray_terracotta": "ljochtgrize terrakotta",
  "block.minecraft.cyan_terracotta": "syane terrakotta",
  "block.minecraft.purple_terracotta": "pearze terrakotta",
  "block.minecraft.blue_terracotta": "blauwe terrakotta",
  "block.minecraft.brown_terracotta": "brune terrakotta",
  "block.minecraft.green_terracotta": "griene terrakotta",
  "block.minecraft.red_terracotta": "reade terrakotta",
  "block.minecraft.black_terracotta": "swarte terrakotta",
  "block.minecraft.barrier": "barriêre",
  "block.minecraft.iron_trapdoor": "izeren fallûk",
  "block.minecraft.hay_block": "klobbe hea",
  "block.minecraft.white_carpet": "wyt tapyt",
  "block.minecraft.orange_carpet": "oranje tapyt",
  "block.minecraft.magenta_carpet": "magenta tapyt",
  "block.minecraft.light_blue_carpet": "ljochtblau tapyt",
  "block.minecraft.yellow_carpet": "giel tapyt",
  "block.minecraft.lime_carpet": "ljochtgrien tapyt",
  "block.minecraft.pink_carpet": "rôze tapyt",
  "block.minecraft.gray_carpet": "griis tapyt",
  "block.minecraft.light_gray_carpet": "ljochtgriis tapyt",
  "block.minecraft.cyan_carpet": "syane tapyt",
  "block.minecraft.purple_carpet": "pears tapyt",
  "block.minecraft.blue_carpet": "blau tapyt",
  "block.minecraft.brown_carpet": "brún tapyt",
  "block.minecraft.green_carpet": "grien tapyt",
  "block.minecraft.red_carpet": "read tapyt",
  "block.minecraft.black_carpet": "swart tapyt",
  "block.minecraft.terracotta": "terrakotta",
  "block.minecraft.coal_block": "blok stienkoal",
  "block.minecraft.packed_ice": "pakiis",
  "block.minecraft.acacia_stairs": "akasiahouten trep",
  "block.minecraft.dark_oak_stairs": "donker ikehouten trep",
  "block.minecraft.slime_block": "slymblok",
  "block.minecraft.grass_path": "gerspaad",
  "block.minecraft.sunflower": "sinneblom",
  "block.minecraft.lilac": "sering",
  "block.minecraft.rose_bush": "roazestrûk",
  "block.minecraft.peony": "pioenroas",
  "block.minecraft.tall_grass": "heech gers",
  "block.minecraft.large_fern": "grutte faren",
  "block.minecraft.white_stained_glass": "wyt kleurd glês",
  "block.minecraft.orange_stained_glass": "oranje kleurd glês",
  "block.minecraft.magenta_stained_glass": "magenta kleurd glês",
  "block.minecraft.light_blue_stained_glass": "ljochtblau kleurd glês",
  "block.minecraft.yellow_stained_glass": "giel kleurd glês",
  "block.minecraft.lime_stained_glass": "ljochtgrien kleurd glês",
  "block.minecraft.pink_stained_glass": "rôze kleurd glês",
  "block.minecraft.gray_stained_glass": "griis kleurd glês",
  "block.minecraft.light_gray_stained_glass": "ljochtgriis kleurd glês",
  "block.minecraft.cyan_stained_glass": "syane kleurd glês",
  "block.minecraft.purple_stained_glass": "pears kleurd glês",
  "block.minecraft.blue_stained_glass": "blau kleurd glês",
  "block.minecraft.brown_stained_glass": "brún kleurd glês",
  "block.minecraft.green_stained_glass": "grien kleurd glês",
  "block.minecraft.red_stained_glass": "read kleurd glês",
  "block.minecraft.black_stained_glass": "swart kleurd glês",
  "block.minecraft.white_stained_glass_pane": "wyt kleurd glês",
  "block.minecraft.orange_stained_glass_pane": "oranje kleurd glês",
  "block.minecraft.magenta_stained_glass_pane": "magenta kleurd glês",
  "block.minecraft.light_blue_stained_glass_pane": "ljochtblau kleurd glês",
  "block.minecraft.yellow_stained_glass_pane": "giel kleurd glês",
  "block.minecraft.lime_stained_glass_pane": "ljochtgrien kleurd glês",
  "block.minecraft.pink_stained_glass_pane": "rôze kleurd glês",
  "block.minecraft.gray_stained_glass_pane": "griis kleurd glês",
  "block.minecraft.light_gray_stained_glass_pane": "ljochtgriis kleurd glês",
  "block.minecraft.cyan_stained_glass_pane": "syaankleure glêspaniel",
  "block.minecraft.purple_stained_glass_pane": "pears kleurd glês",
  "block.minecraft.blue_stained_glass_pane": "blau kleurd glês",
  "block.minecraft.brown_stained_glass_pane": "brún kleurd glês",
  "block.minecraft.green_stained_glass_pane": "grien kleurd glês",
  "block.minecraft.red_stained_glass_pane": "read kleurd glês",
  "block.minecraft.black_stained_glass_pane": "swart kleurd glês",
  "block.minecraft.prismarine": "prismarine",
  "block.minecraft.prismarine_bricks": "prismarine stiennen",
  "block.minecraft.dark_prismarine": "donkere prismarine",
  "block.minecraft.prismarine_stairs": "prismarine trep",
  "block.minecraft.prismarine_brick_stairs": "prismarine stiennen trep",
  "block.minecraft.dark_prismarine_stairs": "donkere prismarine trep",
  "block.minecraft.sea_lantern": "seelantearn",
  "block.minecraft.red_sandstone": "reade sânstien",
  "block.minecraft.chiseled_red_sandstone": "beitele reade sânstien",
  "block.minecraft.cut_red_sandstone": "sneden read sânstien",
  "block.minecraft.red_sandstone_stairs": "reade sânstiennen trep",
  "block.minecraft.repeating_command_block": "werheljend opdrachtblok",
  "block.minecraft.chain_command_block": "keppele opdrachtblok",
  "block.minecraft.magma_block": "magmablok",
  "block.minecraft.nether_wart_block": "nether-krûdblok",
  "block.minecraft.warped_wart_block": "spûkeftich krûdblok",
  "block.minecraft.red_nether_bricks": "reade netherbakstien",
  "block.minecraft.bone_block": "bonkeblok",
  "block.minecraft.structure_void": "struktuerleechte",
  "block.minecraft.observer": "observearder",
  "block.minecraft.shulker_box": "shulker-doaze",
  "block.minecraft.white_shulker_box": "wite shulker-doaze",
  "block.minecraft.orange_shulker_box": "oranje shulker-doaze",
  "block.minecraft.magenta_shulker_box": "magenta shulker-doaze",
  "block.minecraft.light_blue_shulker_box": "ljochtblauwe shulker-doaze",
  "block.minecraft.yellow_shulker_box": "giele shulker-doaze",
  "block.minecraft.lime_shulker_box": "ljochtgriene shulker-doaze",
  "block.minecraft.pink_shulker_box": "rôze shulker-doaze",
  "block.minecraft.gray_shulker_box": "grize shulker-doaze",
  "block.minecraft.light_gray_shulker_box": "ljochtgrize shulker-doaze",
  "block.minecraft.cyan_shulker_box": "syane shulker-doaze",
  "block.minecraft.purple_shulker_box": "pearze shulker-doaze",
  "block.minecraft.blue_shulker_box": "blauwe shulker-doaze",
  "block.minecraft.brown_shulker_box": "brune shulker-doaze",
  "block.minecraft.green_shulker_box": "griene shulker-doaze",
  "block.minecraft.red_shulker_box": "reade shulker-doaze",
  "block.minecraft.black_shulker_box": "swarte shulker-doaze",
  "block.minecraft.white_glazed_terracotta": "wyt glazuere terrakotta",
  "block.minecraft.orange_glazed_terracotta": "oranje glazuere terrakotta",
  "block.minecraft.magenta_glazed_terracotta": "magenta glazuere terrakotta",
  "block.minecraft.light_blue_glazed_terracotta": "ljochtblau glazuere terrakotta",
  "block.minecraft.yellow_glazed_terracotta": "giel glazuere terrakotta",
  "block.minecraft.lime_glazed_terracotta": "ljochtgrien glazuere terrakotta",
  "block.minecraft.pink_glazed_terracotta": "rôze glazuere terrakotta",
  "block.minecraft.gray_glazed_terracotta": "griis glazuere terrakotta",
  "block.minecraft.light_gray_glazed_terracotta": "ljochtgriis glazuere terrakotta",
  "block.minecraft.cyan_glazed_terracotta": "syane glazuere terrakotta",
  "block.minecraft.purple_glazed_terracotta": "pears glazuere terrakotta",
  "block.minecraft.blue_glazed_terracotta": "blau glazuere terrakotta",
  "block.minecraft.brown_glazed_terracotta": "brún glazuere terrakotta",
  "block.minecraft.green_glazed_terracotta": "grien glazuere terrakotta",
  "block.minecraft.red_glazed_terracotta": "read glazuere terrakotta",
  "block.minecraft.black_glazed_terracotta": "swart glazuere terrakotta",
  "block.minecraft.white_concrete": "wyt beton",
  "block.minecraft.orange_concrete": "oranje beton",
  "block.minecraft.magenta_concrete": "magenta beton",
  "block.minecraft.light_blue_concrete": "ljochtblau beton",
  "block.minecraft.yellow_concrete": "giel beton",
  "block.minecraft.lime_concrete": "ljochtgrien beton",
  "block.minecraft.pink_concrete": "rôze beton",
  "block.minecraft.gray_concrete": "griis beton",
  "block.minecraft.light_gray_concrete": "ljochtgriis beton",
  "block.minecraft.cyan_concrete": "syane beton",
  "block.minecraft.purple_concrete": "pears beton",
  "block.minecraft.blue_concrete": "blau beton",
  "block.minecraft.brown_concrete": "brún beton",
  "block.minecraft.green_concrete": "grien beton",
  "block.minecraft.red_concrete": "read beton",
  "block.minecraft.black_concrete": "swart beton",
  "block.minecraft.white_concrete_powder": "wyt semint",
  "block.minecraft.orange_concrete_powder": "oranje semint",
  "block.minecraft.magenta_concrete_powder": "magenta semint",
  "block.minecraft.light_blue_concrete_powder": "ljochtblau semint",
  "block.minecraft.yellow_concrete_powder": "giel semint",
  "block.minecraft.lime_concrete_powder": "ljochtgrien semint",
  "block.minecraft.pink_concrete_powder": "rôze semint",
  "block.minecraft.gray_concrete_powder": "griis semint",
  "block.minecraft.light_gray_concrete_powder": "ljochtgriis semint",
  "block.minecraft.cyan_concrete_powder": "syane semint",
  "block.minecraft.purple_concrete_powder": "pears semint",
  "block.minecraft.blue_concrete_powder": "blau semint",
  "block.minecraft.brown_concrete_powder": "brún semint",
  "block.minecraft.green_concrete_powder": "grien semint",
  "block.minecraft.red_concrete_powder": "read semint",
  "block.minecraft.black_concrete_powder": "swart semint",
  "block.minecraft.turtle_egg": "skyldpodaai",
  "block.minecraft.dead_tube_coral_block": "dea buiskoraalblok",
  "block.minecraft.dead_brain_coral_block": "dea harsenskoraalblok",
  "block.minecraft.dead_bubble_coral_block": "dea blaaskoraalblok",
  "block.minecraft.dead_fire_coral_block": "dea brânkoraalblok",
  "block.minecraft.dead_horn_coral_block": "dea hoarnkoraalblok",
  "block.minecraft.tube_coral_block": "buiskoraalblok",
  "block.minecraft.brain_coral_block": "harsenskoraalblok",
  "block.minecraft.bubble_coral_block": "blaaskoraalblok",
  "block.minecraft.fire_coral_block": "brânkoraalblok",
  "block.minecraft.horn_coral_block": "hoarnkoraalblok",
  "block.minecraft.tube_coral": "buiskoraal",
  "block.minecraft.brain_coral": "harsenskoraal",
  "block.minecraft.bubble_coral": "blaaskoraal",
  "block.minecraft.fire_coral": "brânkoraal",
  "block.minecraft.horn_coral": "hoarnkoraal",
  "block.minecraft.dead_brain_coral": "dea harsenskoraal",
  "block.minecraft.dead_bubble_coral": "dea brobbelkoraal",
  "block.minecraft.dead_fire_coral": "dea fjoerkoraal",
  "block.minecraft.dead_horn_coral": "dea hoarnkoraal",
  "block.minecraft.dead_tube_coral": "dea buiskoraal",
  "block.minecraft.tube_coral_fan": "buisgorgoon",
  "block.minecraft.brain_coral_fan": "harsensgorgoon",
  "block.minecraft.bubble_coral_fan": "blaasgorgoon",
  "block.minecraft.fire_coral_fan": "brângorgoon",
  "block.minecraft.horn_coral_fan": "hoarngorgoon",
  "block.minecraft.dead_tube_coral_fan": "dea buiskoraalwaaier",
  "block.minecraft.dead_brain_coral_fan": "dea harsenskoraalwaaier",
  "block.minecraft.dead_bubble_coral_fan": "dea brobbelkoraalwaaier",
  "block.minecraft.dead_fire_coral_fan": "dea fjoerkoraalwaaier",
  "block.minecraft.dead_horn_coral_fan": "dea hoarnkoraalwaaier",
  "block.minecraft.blue_ice": "blau iis",
  "block.minecraft.conduit": "krêft fan de see",
  "block.minecraft.polished_granite_stairs": "polyste graniten trep",
  "block.minecraft.smooth_red_sandstone_stairs": "glêde reade sânstiennen trep",
  "block.minecraft.mossy_stone_brick_stairs": "moassich blokstiennen trep",
  "block.minecraft.polished_diorite_stairs": "polyste dioriten trep",
  "block.minecraft.mossy_cobblestone_stairs": "moassich keistiennen trep",
  "block.minecraft.end_stone_brick_stairs": "einblokstiennen trep",
  "block.minecraft.stone_stairs": "stiennen trep",
  "block.minecraft.smooth_sandstone_stairs": "glêde sânstiennen trep",
  "block.minecraft.smooth_quartz_stairs": "glêde kwartstrep",
  "block.minecraft.granite_stairs": "graniten trep",
  "block.minecraft.andesite_stairs": "adesiten trep",
  "block.minecraft.red_nether_brick_stairs": "reade netherbakstiennen trep",
  "block.minecraft.polished_andesite_stairs": "polyste andesiten trep",
  "block.minecraft.diorite_stairs": "dioriten rep",
  "block.minecraft.polished_granite_slab": "polyste graniten plaat",
  "block.minecraft.smooth_red_sandstone_slab": "glêde reade sânstiennen plaat",
  "block.minecraft.mossy_stone_brick_slab": "moassich blokstiennen plaat",
  "block.minecraft.polished_diorite_slab": "polyste dioriten plaat",
  "block.minecraft.mossy_cobblestone_slab": "moassich keistiennen plaat",
  "block.minecraft.end_stone_brick_slab": "einblokstiennen plaat",
  "block.minecraft.smooth_sandstone_slab": "glêde sânstiennen plaat",
  "block.minecraft.smooth_quartz_slab": "glêde kwartsplaat",
  "block.minecraft.granite_slab": "graniten plaat",
  "block.minecraft.andesite_slab": "andesiten plaat",
  "block.minecraft.red_nether_brick_slab": "reade netherbakstiennen plaat",
  "block.minecraft.polished_andesite_slab": "polyste andesiten plaat",
  "block.minecraft.diorite_slab": "dioriten plaat",
  "block.minecraft.scaffolding": "steger",
  "block.minecraft.iron_door": "izeren doar",
  "block.minecraft.oak_door": "ikehouten doar",
  "block.minecraft.spruce_door": "spjirrehouten doar",
  "block.minecraft.birch_door": "bjirkehouten doar",
  "block.minecraft.jungle_door": "oerwâldhouten doar",
  "block.minecraft.acacia_door": "akasiahouten doar",
  "block.minecraft.dark_oak_door": "donkere ikehouten doar",
  "block.minecraft.crimson_door": "helreade houten doar",
  "block.minecraft.warped_door": "spûkeftich houten doar",
  "block.minecraft.repeater": "redstone-fersterker",
  "block.minecraft.comparator": "redstone-fergeliker",
  "block.minecraft.structure_block": "struktuerblok",
  "block.minecraft.jigsaw": "puzelblok",
  "item.minecraft.turtle_helmet": "skyldpodskyld□□wannear op de holle:□+2 wapens",
  "item.minecraft.scute": "skyld",
  "item.minecraft.iron_shovel": "izeren skeppe□□wannear yn haadhân:□+3.5 oanfalsskea□-3 oanfalssnelheid",
  "item.minecraft.iron_pickaxe": "izeren houwiel□□wannear yn haadhân:□+3 oanfalsskea□-2.8 oanfalssnelheid",
  "item.minecraft.iron_axe": "izeren bile□□wannear yn haadhân:□+8 oanfalsskea□-3.1 oanfalssnelheid",
  "item.minecraft.flint_and_steel": "fjoerstien en stiel",
  "item.minecraft.apple": "appel",
  "item.minecraft.bow": "bôge",
  "item.minecraft.arrow": "pylk",
  "item.minecraft.coal": "stienkoal",
  "item.minecraft.charcoal": "houtskoal",
  "item.minecraft.diamond": "diamant",
  "item.minecraft.iron_ingot": "izeren stêf",
  "item.minecraft.gold_ingot": "goudstêf",
  "item.minecraft.netherite_ingot": "netheryt-staaf",
  "item.minecraft.netherite_scrap": "netheryt-skroat",
  "item.minecraft.iron_sword": "izeren swurd□□wannear yn haadhân:□+5 oanfalsskea□-2.4 oanfalssnelheid",
  "item.minecraft.wooden_sword": "houten swurd□□wannear yn haadhân:□+3 oanfalsskea□-2.4 oanfalssnelheid",
  "item.minecraft.wooden_shovel": "houten skeppe□□wannear yn haadhân:□+1.5 oanfalsskea□-3 oanfalssnelheid",
  "item.minecraft.wooden_pickaxe": "houten houwiel□□wannear yn haadhân:□+1 oanfalsskea□-2.8 oanfalssnelheid",
  "item.minecraft.wooden_axe": "houten bile□□wannear yn haadhân:□+6 oanfalsskea□-3.2 oanfalssnelheid",
  "item.minecraft.stone_sword": "stiennen swurd□□wannear yn haadhân:□+4 oanfalsskea□-2.4 oanfalssnelheid",
  "item.minecraft.stone_shovel": "stiennen skeppe□□wannear yn haadhân:□+2.5 oanfalsskea□-3 oanfalssnelheid",
  "item.minecraft.stone_pickaxe": "stiennen houwiel□□wannear yn haadhân:□+2 oanfalsskea□-2.8 oanfalssnelheid",
  "item.minecraft.stone_axe": "stiennen bile□□wannear yn haadhân:□+8 oanfalsskea□-3.2 oanfalssnelheid",
  "item.minecraft.diamond_sword": "diamanten swurd□□wannear yn haadhân:□+6 oanfalsskea□-2.4 oanfalssnelheid",
  "item.minecraft.diamond_shovel": "diamanten skeppe□□wannear yn haadhân:□+4.5 oanfalsskea□-3 oanfalssnelheid",
  "item.minecraft.diamond_pickaxe": "diamanten houwiel□□wannear yn haadhân:□+4 oanfalsskea□-2.8 oanfalssnelheid",
  "item.minecraft.diamond_axe": "diamanten bile□□wannear yn haadhân:□+8 oanfalsskea□-3 oanfalssnelheid",
  "item.minecraft.stick": "stôk",
  "item.minecraft.bowl": "kom",
  "item.minecraft.mushroom_stew": "poddestuollensnuorrepot",
  "item.minecraft.golden_sword": "gouden swurd□□wannear yn haadhân:□+3 oanfalsskea□-2.4 oanfalssnelheid",
  "item.minecraft.golden_shovel": "gouden skeppe□□wannear yn haadhân:□+1.5 oanfalsskea□-3 oanfalssnelheid",
  "item.minecraft.golden_pickaxe": "gouden houwiel□□wannear yn haadhân:□+1 oanfalsskea□-2.8 oanfalssnelheid",
  "item.minecraft.golden_axe": "gouden bile□□wannear yn haadhân:□+6 oanfalsskea□-3 oanfalssnelheid",
  "item.minecraft.netherite_sword": "netheryt-swurd□□wannear yn haadhân:□+7 oanfalsskea□-2.4 oanfalssnelheid",
  "item.minecraft.netherite_shovel": "netheryt-skeppe□□wannear yn haadhân:□+5.5 oanfalsskea□-3 oanfalssnelheid",
  "item.minecraft.netherite_pickaxe": "netheryt-pikhouweel□□wannear yn haadhân:□+5 oanfalsskea□-2.8 oanfalssnelheid",
  "item.minecraft.netherite_axe": "netheryt-bile□□wannear yn haadhân:□+9 oanfalsskea□-3 oanfalssnelheid",
  "item.minecraft.string": "tried",
  "item.minecraft.feather": "fear",
  "item.minecraft.gunpowder": "buskrûd",
  "item.minecraft.wooden_hoe": "houten skoffel□□wannear yn haadhân:□-3 oanfalssnelheid",
  "item.minecraft.stone_hoe": "stiennen skoffel□□wannear yn haadhân:□-2 oanfalssnelheid",
  "item.minecraft.iron_hoe": "izeren skoffel□□wannear yn haadhân:□-1 oanfalssnelheid",
  "item.minecraft.diamond_hoe": "diamanten skoffel□□wannear yn haadhân:",
  "item.minecraft.golden_hoe": "gouden skoffel□□wannear yn haadhân:□-3 oanfalssnelheid",
  "item.minecraft.netherite_hoe": "netheryt-skoffel□□wannear yn haadhân:",
  "item.minecraft.wheat_seeds": "weetsied",
  "item.minecraft.wheat": "weet",
  "item.minecraft.bread": "bôle",
  "item.minecraft.leather_helmet": "learen kap□□wannear op de holle:□+1 wapens",
  "item.minecraft.leather_chestplate": "learen tunyk□□wannear op it liif:□+3 wapens",
  "item.minecraft.leather_leggings": "learen broek□□wannear op de skonken:□+2 wapens",
  "item.minecraft.leather_boots": "learen learzens□□wannear op de fuotten:□+1 wapens",
  "item.minecraft.chainmail_helmet": "maljenkap□□wannear op de holle:□+2 wapens",
  "item.minecraft.chainmail_chestplate": "maljenkolder□□wannear op it liif:□+5 wapens",
  "item.minecraft.chainmail_leggings": "maljenbroek□□wannear op de skonken:□+4 wapens",
  "item.minecraft.chainmail_boots": "maljenlearzens□□wannear op de fuotten:□+1 wapens",
  "item.minecraft.iron_helmet": "izeren helm□□wannear op de holle:□+2 wapens",
  "item.minecraft.iron_chestplate": "izeren boarstplaat□□wannear op it liif:□+6 wapens",
  "item.minecraft.iron_leggings": "izeren boksen□□wannear op de skonken:□+5 wapens",
  "item.minecraft.iron_boots": "izeren learzens□□wannear op de fuotten:□+2 wapens",
  "item.minecraft.diamond_helmet": "diamanten helm□□wannear op de holle:□+3 wapens□+2 sterkte wapens",
  "item.minecraft.diamond_chestplate": "diamanten boarstplaat□□wannear op it liif:□+8 wapens□+2 sterkte wapens",
  "item.minecraft.diamond_leggings": "diamanten boksen□□wannear op de skonken:□+6 wapens□+2 sterkte wapens",
  "item.minecraft.diamond_boots": "diamanten learzens□□wannear op de fuotten:□+3 wapens□+2 sterkte wapens",
  "item.minecraft.golden_helmet": "gouden helm□□wannear op de holle:□+2 wapens",
  "item.minecraft.golden_chestplate": "gouden boarstplaat□□wannear op it liif:□+5 wapens",
  "item.minecraft.golden_leggings": "gouden boksen□□wannear op de skonken:□+3 wapens",
  "item.minecraft.golden_boots": "gouden learzens□□wannear op de fuotten:□+1 wapens",
  "item.minecraft.netherite_helmet": "netheryt-helm□□wannear op de holle:□+3 wapens□+3 sterkte wapens□+1 tebekslachbeskerming",
  "item.minecraft.netherite_chestplate": "netheryt-boarstplaat□□wannear op it liif:□+8 wapens□+3 sterkte wapens□+1 tebekslachbeskerming",
  "item.minecraft.netherite_leggings": "netheryt-bienstikken□□wannear op de skonken:□+6 wapens□+3 sterkte wapens□+1 tebekslachbeskerming",
  "item.minecraft.netherite_boots": "netheryt-skuon□□wannear op de fuotten:□+3 wapens□+3 sterkte wapens□+1 tebekslachbeskerming",
  "item.minecraft.flint": "fjoerstien",
  "item.minecraft.porkchop": "rau bargefleis",
  "item.minecraft.cooked_porkchop": "bret bargefleis",
  "item.minecraft.painting": "skilderij",
  "item.minecraft.golden_apple": "gouden appel",
  "item.minecraft.enchanted_golden_apple": "betsjoene gouden appel",
  "block.minecraft.oak_sign": "ikehouten boerd",
  "block.minecraft.spruce_sign": "spjirrehouten boerd",
  "block.minecraft.birch_sign": "bjirkehouten boerd",
  "block.minecraft.jungle_sign": "oerwâldhouten boerd",
  "block.minecraft.acacia_sign": "akasiahouten boerd",
  "block.minecraft.dark_oak_sign": "donker ikehouten boerd",
  "block.minecraft.crimson_sign": "helreade houten boerd",
  "block.minecraft.warped_sign": "spûkeftich houten boerd",
  "item.minecraft.bucket": "amer",
  "item.minecraft.water_bucket": "amer wetter",
  "item.minecraft.lava_bucket": "amer lava",
  "item.minecraft.minecart": "mynkarre",
  "item.minecraft.saddle": "seal",
  "item.minecraft.redstone": "redstonestof",
  "item.minecraft.snowball": "sniebal",
  "item.minecraft.oak_boat": "ikehouten boat",
  "item.minecraft.leather": "lear",
  "item.minecraft.milk_bucket": "amer milk",
  "item.minecraft.pufferfish_bucket": "amer kûgelfisk",
  "item.minecraft.salmon_bucket": "amer salm",
  "item.minecraft.cod_bucket": "amer kabbeljau",
  "item.minecraft.tropical_fish_bucket": "amer tropyske fisk",
  "item.minecraft.brick": "bakstien",
  "item.minecraft.clay_ball": "klaaibal",
  "block.minecraft.dried_kelp_block": "drûge kelpblok",
  "item.minecraft.paper": "papier",
  "item.minecraft.book": "boek",
  "item.minecraft.slime_ball": "slymbal",
  "item.minecraft.chest_minecart": "mynkarre mei kiste",
  "item.minecraft.furnace_minecart": "mynkarre mei oven",
  "item.minecraft.egg": "aai",
  "item.minecraft.compass": "kompas",
  "item.minecraft.fishing_rod": "fiskangel",
  "item.minecraft.clock": "klok",
  "item.minecraft.glowstone_dust": "gleonstienstof",
  "item.minecraft.cod": "rauwe kabeljau",
  "item.minecraft.salmon": "rauwe salm",
  "item.minecraft.tropical_fish": "tropyske fisk",
  "item.minecraft.pufferfish": "kûgelfisk",
  "item.minecraft.cooked_cod": "siede kabeljau",
  "item.minecraft.cooked_salmon": "bakte salm",
  "item.minecraft.ink_sac": "inketsek",
  "item.minecraft.red_dye": "reade kleurstof",
  "item.minecraft.green_dye": "griene kleurstof",
  "item.minecraft.cocoa_beans": "kakaobeane",
  "item.minecraft.lapis_lazuli": "lapis lazuli",
  "item.minecraft.purple_dye": "pearze kleurstof",
  "item.minecraft.cyan_dye": "syane kleurstof",
  "item.minecraft.light_gray_dye": "ljochtgrize kleurstof",
  "item.minecraft.gray_dye": "grize kleurstof",
  "item.minecraft.pink_dye": "rôze kleurstof",
  "item.minecraft.lime_dye": "ljochtgriene kleurstof",
  "item.minecraft.yellow_dye": "giele kleurstof",
  "item.minecraft.light_blue_dye": "ljochtblauwe kleurstof",
  "item.minecraft.magenta_dye": "magenta kleurstof",
  "item.minecraft.orange_dye": "oranje kleurstof",
  "item.minecraft.bone_meal": "bonkemoal",
  "item.minecraft.blue_dye": "blauwe kleurstof",
  "item.minecraft.brown_dye": "brune kleurstof",
  "item.minecraft.black_dye": "swarte kleurstof",
  "item.minecraft.white_dye": "wite kleurstof",
  "item.minecraft.bone": "bonke",
  "item.minecraft.sugar": "sûker",
  "block.minecraft.cake": "taart",
  "block.minecraft.white_bed": "wyt bêd",
  "block.minecraft.orange_bed": "oranje bêd",
  "block.minecraft.magenta_bed": "magenta bêd",
  "block.minecraft.light_blue_bed": "ljochtblau bêd",
  "block.minecraft.yellow_bed": "giel bêd",
  "block.minecraft.lime_bed": "ljochtgrien bêd",
  "block.minecraft.pink_bed": "rose bêd",
  "block.minecraft.gray_bed": "griis bêd",
  "block.minecraft.light_gray_bed": "ljocht griis bêd",
  "block.minecraft.cyan_bed": "syane bêd",
  "block.minecraft.purple_bed": "pears bêd",
  "block.minecraft.blue_bed": "blau bêd",
  "block.minecraft.brown_bed": "brún bêd",
  "block.minecraft.green_bed": "grien bêd",
  "block.minecraft.red_bed": "read bêd",
  "block.minecraft.black_bed": "swart bêd",
  "item.minecraft.cookie": "koekje",
  "item.minecraft.filled_map": "kaart□#0",
  "item.minecraft.shears": "skjirre",
  "item.minecraft.melon_slice": "meloenskiif",
  "item.minecraft.dried_kelp": "droege kelp",
  "item.minecraft.pumpkin_seeds": "pompoensieden",
  "item.minecraft.melon_seeds": "wettermeloensieden",
  "item.minecraft.beef": "rau kowefleis",
  "item.minecraft.cooked_beef": "byfstik",
  "item.minecraft.chicken": "rauwe hin",
  "item.minecraft.cooked_chicken": "brette hin",
  "item.minecraft.rotten_flesh": "bedoarn fleis",
  "item.minecraft.ender_pearl": "ender-pearel",
  "item.minecraft.blaze_rod": "blazestêf",
  "item.minecraft.ghast_tear": "ghast-trien",
  "item.minecraft.gold_nugget": "goudklompke",
  "item.minecraft.nether_wart": "nether-krûd",
  "item.minecraft.potion": "net te meitsjen drank□gjin effekten",
  "item.minecraft.glass_bottle": "glêzen fleske",
  "item.minecraft.spider_eye": "spinne-each",
  "item.minecraft.fermented_spider_eye": "fermintearre spinne-each",
  "item.minecraft.blaze_powder": "blazepoeier",
  "item.minecraft.magma_cream": "magmakrême",
  "block.minecraft.brewing_stand": "broustandert",
  "block.minecraft.cauldron": "tsjettel",
  "item.minecraft.ender_eye": "ender-each",
  "item.minecraft.glistering_melon_slice": "glinsterjende meloenskiif",
  "item.minecraft.bat_spawn_egg": "flearmûzespawnaai",
  "item.minecraft.bee_spawn_egg": "bijespawnaai",
  "item.minecraft.blaze_spawn_egg": "blazespawnaai",
  "item.minecraft.cat_spawn_egg": "kattespawnaai",
  "item.minecraft.cave_spider_spawn_egg": "grottenspinnespawnaai",
  "item.minecraft.chicken_spawn_egg": "hinnespawnaai",
  "item.minecraft.cod_spawn_egg": "kabeljauspawnaai",
  "item.minecraft.cow_spawn_egg": "kowespawnaai",
  "item.minecraft.creeper_spawn_egg": "creeperspawnaai",
  "item.minecraft.dolphin_spawn_egg": "dolfinespawnaai",
  "item.minecraft.donkey_spawn_egg": "ezelspawnaai",
  "item.minecraft.drowned_spawn_egg": "drinkelingespawnaai",
  "item.minecraft.elder_guardian_spawn_egg": "aldebewakerspawnaai",
  "item.minecraft.enderman_spawn_egg": "endermannespawnaai",
  "item.minecraft.endermite_spawn_egg": "endermitespawnaai",
  "item.minecraft.evoker_spawn_egg": "opropperspawnaai",
  "item.minecraft.fox_spawn_egg": "foksspawnaai",
  "item.minecraft.ghast_spawn_egg": "ghastspawnaai",
  "item.minecraft.guardian_spawn_egg": "bewakerspawnaai",
  "item.minecraft.hoglin_spawn_egg": "hoglin spawn aai",
  "item.minecraft.horse_spawn_egg": "hynstespawnaai",
  "item.minecraft.husk_spawn_egg": "mummyspawnaai",
  "item.minecraft.llama_spawn_egg": "lamaspawnaai",
  "item.minecraft.magma_cube_spawn_egg": "magmakubusspawnaai",
  "item.minecraft.mooshroom_spawn_egg": "mooshroomspawnaai",
  "item.minecraft.mule_spawn_egg": "mûlezelspawnaai",
  "item.minecraft.ocelot_spawn_egg": "ocelottespawnaai",
  "item.minecraft.panda_spawn_egg": "pandaspawnaai",
  "item.minecraft.parrot_spawn_egg": "pappegaaiespawnaai",
  "item.minecraft.phantom_spawn_egg": "fantomespawnaai",
  "item.minecraft.pig_spawn_egg": "bargespawnaai",
  "item.minecraft.piglin_spawn_egg": "piglinspawnaai",
  "item.minecraft.pillager_spawn_egg": "rôverspawnaai",
  "item.minecraft.polar_bear_spawn_egg": "iisbearespawnaai",
  "item.minecraft.pufferfish_spawn_egg": "kûgelfiskespawnaai",
  "item.minecraft.rabbit_spawn_egg": "kninespawnaai",
  "item.minecraft.ravager_spawn_egg": "ferwoasterspawnaai",
  "item.minecraft.salmon_spawn_egg": "salmspawnaai",
  "item.minecraft.sheep_spawn_egg": "skiepespawnaai",
  "item.minecraft.shulker_spawn_egg": "shulkerspawnaai",
  "item.minecraft.silverfish_spawn_egg": "silverfiskespawnaai",
  "item.minecraft.skeleton_spawn_egg": "skelettespawnaai",
  "item.minecraft.skeleton_horse_spawn_egg": "skelettehynderspawnaai",
  "item.minecraft.slime_spawn_egg": "slymkubusspawnaai",
  "item.minecraft.spider_spawn_egg": "spinnespawnaai",
  "item.minecraft.squid_spawn_egg": "inketfiskespawnaai",
  "item.minecraft.stray_spawn_egg": "swalkerspawnaai",
  "item.minecraft.strider_spawn_egg": "lavariderspawnaai",
  "item.minecraft.trader_llama_spawn_egg": "hannelerslamaspawnaai",
  "item.minecraft.tropical_fish_spawn_egg": "tropyskefiskenspawnaai",
  "item.minecraft.turtle_spawn_egg": "skyldpoddenspawnaai",
  "item.minecraft.vex_spawn_egg": "ergernissenspawnaai",
  "item.minecraft.villager_spawn_egg": "doarpelingenspawnaai",
  "item.minecraft.vindicator_spawn_egg": "ferdigenerspawnaai",
  "item.minecraft.wandering_trader_spawn_egg": "rûnreizigjendehannelersspawnaai",
  "item.minecraft.witch_spawn_egg": "heksespawnaai",
  "item.minecraft.wither_skeleton_spawn_egg": "witherskelettenspawnaai",
  "item.minecraft.wolf_spawn_egg": "wolvenspawnaai",
  "item.minecraft.zoglin_spawn_egg": "zoglinspawnaai",
  "item.minecraft.zombie_spawn_egg": "sombyspawnaai",
  "item.minecraft.zombie_horse_spawn_egg": "sombyhynstespawnaai",
  "item.minecraft.zombie_villager_spawn_egg": "sombydoarpelingenspawnaai",
  "item.minecraft.zombified_piglin_spawn_egg": "sombypiglinspawnaai",
  "item.minecraft.experience_bottle": "tsjoendersflesse",
  "item.minecraft.fire_charge": "fjoerbal",
  "item.minecraft.writable_book": "boek en guozzefear",
  "item.minecraft.written_book": "skreaune boek",
  "item.minecraft.emerald": "smaragd",
  "item.minecraft.item_frame": "foarwerplist",
  "block.minecraft.flower_pot": "blompot",
  "item.minecraft.carrot": "woartel",
  "item.minecraft.potato": "ierappel",
  "item.minecraft.baked_potato": "bakte ierappel",
  "item.minecraft.poisonous_potato": "fergiftige ierappel",
  "item.minecraft.map": "lege kaart",
  "item.minecraft.golden_carrot": "gouden woartel",
  "block.minecraft.skeleton_skull": "deadskop",
  "block.minecraft.wither_skeleton_skull": "wither-bonkerakkekop",
  "block.minecraft.player_head": "spilerholle",
  "block.minecraft.zombie_head": "sombykop",
  "block.minecraft.creeper_head": "creeper-kop",
  "block.minecraft.dragon_head": "drakekop",
  "item.minecraft.carrot_on_a_stick": "woartel oan in stôk",
  "item.minecraft.warped_fungus_on_a_stick": "spûkeftige swam oan in stûk",
  "item.minecraft.nether_star": "nether-stjer",
  "item.minecraft.pumpkin_pie": "pompoentaart",
  "item.minecraft.firework_rocket": "fjoerpylk",
  "item.minecraft.firework_star": "fjoerwurkstjer",
  "item.minecraft.enchanted_book": "betsjoene boek",
  "item.minecraft.nether_brick": "nether-bakstiennen",
  "item.minecraft.quartz": "nether-kwarts",
  "item.minecraft.tnt_minecart": "mynkarre mei tnt",
  "item.minecraft.hopper_minecart": "mynkarre mei trachter",
  "item.minecraft.prismarine_shard": "prismarineskerf",
  "item.minecraft.prismarine_crystals": "prismarinekristallen",
  "item.minecraft.rabbit": "rau kninefleis",
  "item.minecraft.cooked_rabbit": "bret kninefleis",
  "item.minecraft.rabbit_stew": "kninesnuorrepot",
  "item.minecraft.rabbit_foot": "kninepoatsje",
  "item.minecraft.rabbit_hide": "kninefel",
  "item.minecraft.armor_stand": "wapenhâlder",
  "item.minecraft.iron_horse_armor": "izeren hynsteharnas",
  "item.minecraft.golden_horse_armor": "gouden hynsteharnas",
  "item.minecraft.diamond_horse_armor": "diamanten hynsteharnas",
  "item.minecraft.leather_horse_armor": "learen hynderharnas",
  "item.minecraft.lead": "riem",
  "item.minecraft.name_tag": "nammelabel",
  "item.minecraft.command_block_minecart": "mynkarre mei opdrachtblok",
  "item.minecraft.mutton": "rau skieppefleis",
  "item.minecraft.cooked_mutton": "bret skieppefleis",
  "block.minecraft.white_banner": "wite banier",
  "block.minecraft.orange_banner": "oranje banier",
  "block.minecraft.magenta_banner": "magenta banier",
  "block.minecraft.light_blue_banner": "ljochtblauwe banier",
  "block.minecraft.yellow_banner": "giele banier",
  "block.minecraft.lime_banner": "ljochtgriene banier",
  "block.minecraft.pink_banner": "rôze banier",
  "block.minecraft.gray_banner": "grize banier",
  "block.minecraft.light_gray_banner": "ljochtgrize banier",
  "block.minecraft.cyan_banner": "syane banier",
  "block.minecraft.purple_banner": "pearze banier",
  "block.minecraft.blue_banner": "blauwe banier",
  "block.minecraft.brown_banner": "brune banier",
  "block.minecraft.green_banner": "griene banier",
  "block.minecraft.red_banner": "reade banier",
  "block.minecraft.black_banner": "swarte banier",
  "item.minecraft.end_crystal": "end-kristal",
  "item.minecraft.chorus_fruit": "koarfrucht",
  "item.minecraft.popped_chorus_fruit": "pofte koarfrucht",
  "item.minecraft.beetroot": "byt",
  "item.minecraft.beetroot_seeds": "bitesieden",
  "item.minecraft.beetroot_soup": "bitesop",
  "item.minecraft.dragon_breath": "drake-azem",
  "item.minecraft.splash_potion": "net te meitsjen spattende drank□gjin effekten",
  "item.minecraft.spectral_arrow": "spektrale pylk",
  "item.minecraft.tipped_arrow": "net te meitsjen tipte pylk□gjin effekten",
  "item.minecraft.lingering_potion": "net te meitsjen oanhâldende drank□gjin effekten",
  "item.minecraft.shield": "skyld",
  "item.minecraft.elytra": "dekskyld",
  "item.minecraft.spruce_boat": "spjirrehouten boat",
  "item.minecraft.birch_boat": "bjirkehouten boat",
  "item.minecraft.jungle_boat": "oerwâldhouten boat",
  "item.minecraft.acacia_boat": "akasiahouten boat",
  "item.minecraft.dark_oak_boat": "donkere ikehouten boat",
  "item.minecraft.totem_of_undying": "toatem fan ûnstjerlikheid",
  "item.minecraft.shulker_shell": "shulker-skelp",
  "item.minecraft.iron_nugget": "izerklompke",
  "item.minecraft.knowledge_book": "boek fan kennis",
  "item.minecraft.debug_stick": "debugstôk",
  "item.minecraft.music_disc_13": "muzykplaat□c418 - 13",
  "item.minecraft.music_disc_cat": "muzykplaat□c418 - cat",
  "item.minecraft.music_disc_blocks": "muzykplaat□c418 - blocks",
  "item.minecraft.music_disc_chirp": "muzykplaat□c418 - chirp",
  "item.minecraft.music_disc_far": "muzykplaat□c418 - far",
  "item.minecraft.music_disc_mall": "muzykplaat□c418 - mall",
  "item.minecraft.music_disc_mellohi": "muzykplaat□c418 - mellohi",
  "item.minecraft.music_disc_stal": "muzykplaat□c418 - stal",
  "item.minecraft.music_disc_strad": "muzykplaat□c418 - strad",
  "item.minecraft.music_disc_ward": "muzykplaat□c418 - ward",
  "item.minecraft.music_disc_11": "muzykplaat□c418 - 11",
  "item.minecraft.music_disc_wait": "muzykplaat□c418 - wait",
  "item.minecraft.music_disc_pigstep": "muzykplaat□lena raine - pigstep",
  "item.minecraft.trident": "trijetyn□□wannear yn haadhân:□+8 oanfalsskea□-2.9 oanfalssnelheid",
  "item.minecraft.phantom_membrane": "fantoommembraan",
  "item.minecraft.nautilus_shell": "nautilusskelp",
  "item.minecraft.heart_of_the_sea": "hert fan de see",
  "item.minecraft.crossbow": "krúsbôge",
  "item.minecraft.suspicious_stew": "geheimsinnige stoofpot",
  "block.minecraft.loom": "weeftou",
  "item.minecraft.flower_banner_pattern": "banierpatroan□blomwapen",
  "item.minecraft.creeper_banner_pattern": "banierpatroan□creeperwapen",
  "item.minecraft.skull_banner_pattern": "banierpatroan□deadskopwapen",
  "item.minecraft.mojang_banner_pattern": "banierpatroan□mojangwapen",
  "item.minecraft.globe_banner_pattern": "banierpatroan□globe",
  "item.minecraft.piglin_banner_pattern": "banierpatroan□snút",
  "block.minecraft.composter": "kompostbult",
  "block.minecraft.barrel": "fet",
  "block.minecraft.smoker": "smoker",
  "block.minecraft.blast_furnace": "heechoven",
  "block.minecraft.cartography_table": "kartografytafel",
  "block.minecraft.fletching_table": "bewapeningstafel",
  "block.minecraft.grindstone": "slypstien",
  "block.minecraft.lectern": "lessener",
  "block.minecraft.smithing_table": "smeitafel",
  "block.minecraft.stonecutter": "stiensliper",
  "block.minecraft.bell": "bel",
  "block.minecraft.lantern": "lantearne",
  "block.minecraft.soul_lantern": "sielelantearn",
  "item.minecraft.sweet_berries": "swietbessen",
  "block.minecraft.campfire": "kampfjoer",
  "block.minecraft.soul_campfire": "sielekampfjoer",
  "block.minecraft.shroomlight": "swammeljocht",
  "item.minecraft.honeycomb": "huningraat",
  "block.minecraft.bee_nest": "bijenêst",
  "block.minecraft.beehive": "bijekoer",
  "item.minecraft.honey_bottle": "huningfles",
  "block.minecraft.honey_block": "huningblok",
  "block.minecraft.honeycomb_block": "huningraatblok",
  "block.minecraft.lodestone": "seilstien",
  "block.minecraft.netherite_block": "netherietblok",
  "block.minecraft.ancient_debris": "ald pún",
  "block.minecraft.target": "doel",
  "block.minecraft.crying_obsidian": "gûlende obsidiaan",
  "block.minecraft.blackstone": "swartstien",
  "block.minecraft.blackstone_slab": "swartstiennen plaat",
  "block.minecraft.blackstone_stairs": "swartstiennen trep",
  "block.minecraft.gilded_blackstone": "fergulde swartstien",
  "block.minecraft.polished_blackstone": "polyste swartstien",
  "block.minecraft.polished_blackstone_slab": "polyste swartstiennen plaat",
  "block.minecraft.polished_blackstone_stairs": "polyste swartstiennen treppen",
  "block.minecraft.chiseled_polished_blackstone": "beitele polyste swartstien",
  "block.minecraft.polished_blackstone_bricks": "polyste swartstiennen blokstiennen",
  "block.minecraft.polished_blackstone_brick_slab": "polyste swartstiennen blokstiennen plaat",
  "block.minecraft.polished_blackstone_brick_stairs": "polyste swartstiennen blokstiennen trep",
  "block.minecraft.cracked_polished_blackstone_bricks": "beitele polyste swartstiennen bakstien",
  "block.minecraft.respawn_anchor": "respawnanker",
}
export const fy_nl = items; 
